export enum ChartsUserEvents {
    // Chart Card
    ChartCardClick = "Charts - Chart Card Click",
    ChartCardClickView = "Charts - Chart Card - Click View Button",
    ChartCardClickEdit = "Charts - Chart Card - Click Edit Button",
    ChartCardClickClone = "Charts - Chart Card - Click Clone Button",
    ChartCardCloneUpgradeView = "Charts - Chart Card - Clone Upgrade - View",
    ChartCardCloneUpgradeViewPricing = "Charts - Chart Card - Clone Upgrade - Click View Pricing",
    ChartCardClickDelete = "Charts - Chart Card - Click Delete Button",
    ChartCardClickAddFavorite = "Charts - Chart Card - Add Favorite",
    ChartCardClickRemoveFavorite = "Charts - Chart Card - Remove Favorite",

    // List Page
    ChartListClickCreateChart = "Charts - List Page - Click Create Chart Button",
    ChartListClickCreateChartEmptyState = "Charts - List Page - Click Create Chart Button - Empty State",
    ChartListCreateChartPaywallView = "Charts - List Page - Create Chart Paywall - View",
    ChartListCreateChartPaywallViewPricing = "Charts - List Page - Create Chart Paywall - Click View Pricing",
    ChartListClickTab = "Charts - List Page - Click Tab",
    ChartListSort = "Charts - List Page - Sort",
    ChartFilterType = "Charts - List Page - Filter Type",
    ChartListClickExplore = "Charts - List Page - Click Explore Link",
    // ChartListSearch = "Charts - List Page - Search",

    // Individual Page
    ChartIndividualClickEdit = "Charts - Individual Page - Click Edit Button",
    ChartIndividualClickDelete = "Charts - Individual Page - Click Delete Button",
    ChartIndividualClickClone = "Charts - Individual Page - Click Clone Button",
    ChartIndividualCloneUpgradeView = "Charts - Individual Page - Clone Upgrade - View",
    ChartIndividualCloneUpgradeViewPricing = "Charts - Individual Page - Clone Upgrade - Click View Pricing",
    ChartIndividualClickView = "Charts - Individual Page - Click View Button",
    ChartIndividualClickFavoriteAdd = "Charts - Individual Page - Add Favorite",
    ChartIndividualClickFavoriteRemove = "Charts - Individual Page - Remove Favorite",

    // Not found
    ChartNotFoundClickViewCharts = "Charts - Not Found - Click View All Charts",

    // Chart Form
    ChartFormChangeTab = "Charts - Form - Change Tab",

    // Chart New Page
    ChartCreateSubmit = "Charts - New Page - Submit Form",
    ChartCreateCancel = "Charts - New Page - Click Cancel Button",
    ChartNewUpgradeView = "Charts - New Page - Upgrade CTA - View",
    ChartNewUpgradeViewPricing = "Charts - New Page - Upgrade CTA - Click View Pricing",

    // Chart Edit Page
    ChartUpdateSubmit = "Charts - Edit Page - Submit Form",
    ChartUpdateCancel = "Charts - Edit Page - Click Cancel Button",
    ChartEditNoAccessClone = "Charts - Edit Page - No Access - Click Clone Button",
    ChartEditNoAccessGoBack = "Charts - Edit Page - No Access - Click Go Back Button",

    // Explore
    ChartOpenInExplore = "Charts - Open in Explore",
    ChartExploreClickSaveChart = "Charts - Explore Page - Click Save Chart Button",
    ChartExploreSaveChartSubmit = "Charts - Explore Page - Save Chart - Submit",
    ChartExploreSaveChartCancel = "Charts - Explore Page - Save Chart - Cancel",
    ChartExploreSaveChartPaywallView = "Charts - Explore Page - Save Chart Paywall - View",
    ChartExploreSaveChartPaywallViewPricing = "Charts - Explore Page - Save Chart Paywall - Click View Pricing",
}
